export var FilterType = /*#__PURE__*/ function(FilterType) {
    FilterType["CompanyName"] = "companyName";
    FilterType["AgreementName"] = "agreement";
    FilterType["IssueDate"] = "issueDate";
    FilterType["DueDate"] = "dueDate";
    FilterType["RequiresApproval"] = "requiresApproval";
    return FilterType;
}({});
export const filterLabels = {
    ["companyName"]: 'Company name',
    ["agreement"]: 'Agreement name',
    ["issueDate"]: 'Issue date',
    ["dueDate"]: 'Due date',
    ["requiresApproval"]: 'Requires approval'
};
export var RequiresApproval = /*#__PURE__*/ function(RequiresApproval) {
    RequiresApproval["Yes"] = "Yes";
    RequiresApproval["No"] = "No";
    return RequiresApproval;
}({});
export var FutureInvoicesReportSortColumnId = /*#__PURE__*/ function(FutureInvoicesReportSortColumnId) {
    FutureInvoicesReportSortColumnId["CompanyName"] = "companyName";
    FutureInvoicesReportSortColumnId["IssueDate"] = "issueDate";
    FutureInvoicesReportSortColumnId["DueDate"] = "dueDate";
    FutureInvoicesReportSortColumnId["RequiresApproval"] = "requiresApproval";
    FutureInvoicesReportSortColumnId["Total"] = "total";
    return FutureInvoicesReportSortColumnId;
}({});
